import { SegmentsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { SEGMENTS_API_URL } = process.env;

export default new SegmentsApi(SEGMENTS_API_URL, {}, olyEngineApi);
